// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__IEWxi","title":"TextArea_title__bH_xA"};